/*global jimdoData, perfBar */
var $ = require('jquery');

function loadPerformanceTrackingScript() {
    return Promise.resolve($.getScript('//uim.tifbs.net/js/1086.js'))
        .then(function () {
            NSfTIF.track(jimdoData.personaTrackingData);
        });
}

function waitForPageLoad() {
    return new Promise(function(resolve, reject) {
        $(window).on('load', function() {
            resolve();
        });
    });
}

function trackPerformance() {
    if (jimdoData.performanceTrackingEnabled) {
        NSfTIF.performance(jimdoData.performanceTrackingData);
    }
}

function onFail(reason) {
    throw new Error('Performance tracking error: ' + reason.toString());
}

function init() {
    var onLoadPromise = waitForPageLoad();

    Promise.all([
        loadPerformanceTrackingScript(),
        onLoadPromise
    ])
    .then(trackPerformance)
    .catch(onFail);

    if (jimdoData.performanceTrackingEnabled) {
        onLoadPromise
            .then(function () {
                if (perfBar) {
                    setTimeout(function () {
                        perfBar.init(jimdoData.performanceBarData);
                        perfBar.send();
                    }, 1000);
                }
            })
            .catch(onFail);
    }
}

module.exports = {
    init: init
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/performanceTracking/performanceTracking.js
 ** module id = 886
 ** module chunks = 0
 **/